
import axios from 'axios'

function updatePreferences(preferences) {
    var urlString = `${process.env.VUE_APP_APIURL}/preferences`;
    return axios
        .put(urlString, preferences)
        .then(res => res.data);
}
function getPermissions() {
    var urlString = `${process.env.VUE_APP_APIURL}/permissions`;
    return axios
        .get(urlString)
        .then(res => res.data);
}

function getRoles() {
    var urlString = `${process.env.VUE_APP_APIURL}/role`;
    return axios
        .get(urlString)
        .then(res => res.data);
}

function createRole(role) {
    var urlString = `${process.env.VUE_APP_APIURL}/role`;
    return axios
        .post(urlString, role)
        .then(res => res.data._id);
}
function getTelemetrySources(){
    var urlString = `${process.env.VUE_APP_APIURL}/telemetry/sources`;
    return axios
        .get(urlString)
        .then(res => res.data);
}
function updateRole(role) {
    var urlString = `${process.env.VUE_APP_APIURL}/role/${role._id}`;
    return axios
        .put(urlString, role)
        .then(res => res.data._id);
}

function deleteRole(roleName) {
    var urlString = `${process.env.VUE_APP_APIURL}/role/${roleName}`;
    return axios
        .delete(urlString)
        .then(res => res.data);
}

function getTelemetry() {
    var urlString = `${process.env.VUE_APP_APIURL}/telemetry`;
    return axios
        .get(urlString)
        .then(res => res.data);
}

function createTelemetry(telemetry) {
    var urlString = `${process.env.VUE_APP_APIURL}/telemetry`;
    return axios
        .post(urlString, telemetry)
        .then(res => res.data._id);
}
function updateTelemetryOrder(telemetries){
    var urlString = `${process.env.VUE_APP_APIURL}/telemetry/order`;
    return axios
        .put(urlString, telemetries)
        .then(res => res.data._id);
}
function updateTelemetry(telemetry) {
    var urlString = `${process.env.VUE_APP_APIURL}/telemetry/${telemetry._id}`;
    return axios
        .put(urlString, telemetry)
        .then(res => res.data._id);
}

function deleteTelemetry(name) {
    var urlString = `${process.env.VUE_APP_APIURL}/telemetry/${name}`;
    return axios
        .delete(urlString)
        .then(res => res.data);
}

function getUsers() {
    var urlString = `${process.env.VUE_APP_APIURL}/users`;
    return axios
        .get(urlString)
        .then(res => {
            return res.data.map((x) => { return { ...x, resetPasswordVisible: false } })
        });
}

function createUser(user) {
    var urlString = `${process.env.VUE_APP_APIURL}/users`;
    return axios
        .post(urlString, user)
        .then(res => res.data._id);
}

function getSigv4Url() {
    var urlString = `${process.env.VUE_APP_APIURL}/iot/sigv4`;
    return axios
        .get(urlString)
        .then(res => res.data);
}
function updateUser(user) {
    var urlString = `${process.env.VUE_APP_APIURL}/users/${user._id}`;
    return axios
        .put(urlString, user)
        .then(res => res.data._id);
}

function deleteUser(userId) {
    var urlString = `${process.env.VUE_APP_APIURL}/users/${userId}`;
    return axios
        .delete(urlString)
        .then(res => res.data);
}
export default {
    getUsers,
    getSigv4Url,
    createUser,
    updateUser,
    deleteUser,
    getTelemetry,
    updatePreferences,
    createTelemetry,
    updateTelemetry,
    deleteTelemetry,
    getRoles,
    createRole,
    updateRole,
    deleteRole,
    getPermissions,
    updateTelemetryOrder,
    getTelemetrySources
};